<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              新東陽 註銷會員
            </b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>

    <b-card>
      <div class="row mb-2 align-items-end">
        <div class="col-8 d-flex items-center">
          <h4 class="font-weight-bold">新東陽 註銷會員</h4>
        </div>
      </div>

      <b-overlay
        :show="isLoading"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
      >
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="會員編號"
        >
          <b-input-group>
            <b-form-input
              class="mb-2 mr-sm-2 mb-sm-0"
              type="text"
              v-model="customer_no"
              placeholder="請輸入會員編號"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                class="mr-2"
                variant="info"
                @click="handleDelete"
                :disabled="isLoading"
              >
              註銷
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback :state="!v$.customer_no.$error">
              此欄位為必填
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <editor
          class="mb-2 mr-sm-2 mb-sm-0"
          v-model="result"
          width="100%"
          height="300px"
          @init="editorInit"
          lang="json"
          theme="chrome"
          :disabled="1"
        >
        </editor>
      </b-overlay>
    </b-card>
  </div>
</template>

<style scoped lang="scss">
.group + .group {
  border-top: 1px solid #cdd6dc !important;
}
</style>
<script>
import { mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import * as consts from "@/consts";
import PermissionChecker from "@/utils/PermissionChecker";
import editor from "vue2-ace-editor";
import fileMixin from "@/mixins/uploadFile";
import htyApi from "@/apis/hty"
import {required} from "@vuelidate/validators";


export default {
  mixins: [fileMixin],
  components: { editor },
  validationConfig: {
    $lazy: true,
  },
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      customer_no: {
        required
      },
    };
  },
  data() {
    /*
     *  由於欄位是個動態 array ，因此 vuelidate 幾乎觸發不了驗證
     * ，因此編輯時暫時將
     *  forms = [{key: 'k', value: 'v'}]
     *  轉為form = {k:v}
     *  最後 submit 再轉換回來
     */
    return {
      code: null,
      customer_no: null,
      result: "",
      color: "",
      isLoading: false,
      isSubmitting: false,
      formGroups: {},
      module: {},
      fetchedVariableId: null,
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    orgId() {
      return this.organization.id;
    }
  },
  mounted() {
    if (!this.checkPermission([consts.HTY_LMS_SETTING_DELETE_ACCOUNT])) {
      this.$swal
        .fire({
          type: "error",
          text: "你沒有權限訪問此頁面",
          confirmButtonColor: "#d33",
        })
        .then(() => {
          this.$router.push({
            name: "OrganizationVariableList",
          });
        });
    }
  },
  methods: {
    editorInit() {
      require("brace/ext/language_tools"); //language extension prerequsite...
      require("brace/mode/json");
      require("brace/mode/html");
      require("brace/theme/chrome");
    },
    async handleDelete() {
      const result = await this.v$.$validate();
      if (!result) return;

      try {
        this.isSubmitting = true;
        this.result = "查詢中...";
        const result = await htyApi.deleteAccount({ customer_no: this.customer_no });
        this.result = JSON.stringify(result.data, null, 2);
      } catch (error) {
        this.result = JSON.stringify(error.response.data, null, 2);
      }
      this.isSubmitting = false;
    },

    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },
  },
};
</script>
